module.exports = __webpack_public_path__ + "static/media/gragea.69c6d8e6.png";